import {hasSpeechRecognitionSupport} from "./browser-support";

export function createSpeechRecognition(): SpeechRecognition | null {
  const hasSupport = hasSpeechRecognitionSupport();

  if (!hasSupport) {
    console.warn("Speech Recognition not supported in this browser");
    return null;
  }

  // Get the SpeechRecognition constructor from the browser
  const SpeechRecognitionConstructor = window.SpeechRecognition || window.webkitSpeechRecognition;

  // Create a new instance of the speech recognition interface
  const speechRecognition = new SpeechRecognitionConstructor();

  // Configure the speech recognition instance
  speechRecognition.lang = "en-GB";

  return speechRecognition;
}